import http from './httpClient';

class OrdersApiService {
  // Получение списка заказов для админов
  async getAdminOrdersList(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page);
    if (params.page_size) searchParams.append('page_size', params.page_size);
    if (params.status && params.status !== 'all') searchParams.append('status', params.status);
    if (params.search) searchParams.append('search', params.search);
    const url = `/api/orders/admin/list/?${searchParams.toString()}`;
    const response = await http.get(url);
    return response.data;
  }

  // Обновление статуса заказа (для админов)
  async updateOrderStatus(orderId, status) {
    const response = await http.post(`/api/orders/admin/${orderId}/status/`, { status });
    return response.data;
  }

  // Получение деталей заказа
  async getOrderDetails(orderId) {
    const response = await http.get(`/api/orders/${orderId}/`);
    return response.data;
  }

  // Получение статистики заказов
  async getOrdersStats() {
    const response = await http.get(`/api/orders/stats/`);
    return response.data;
  }
}

const ordersApiService = new OrdersApiService();
export default ordersApiService;